import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import { handleLogin } from '../../auth/apiAuth';

const DeletionBanner = ({
  permanentlyDeletedAt,
}: {
  permanentlyDeletedAt: string;
}) => {
  const { isAuthenticated, customerAccountStatus } = useAuth();
  const navigate = useNavigate();

  const remainingDays = Math.ceil(
    (new Date(permanentlyDeletedAt).getTime() - new Date().getTime()) /
      (1000 * 60 * 60 * 24)
  );

  const formattedDate = new Date(permanentlyDeletedAt).toLocaleDateString(
    'en-US',
    {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }
  );

  const handleNavigate = () => {
    if (customerAccountStatus !== 'pending_deletion') {
      navigate('/');
    }
    if (!isAuthenticated) {
      handleLogin();
    }
    navigate('/customer/customer-profile');
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/40 px-5 py-3 md:py-1 w-full flex flex-col md:flex-row items-center md:items-center justify-center gap-2">
      <div>
        <p className="text-xs text-amber-800 text-center md:text-left leading-relaxed">
          Your account is scheduled for permanent deletion in{' '}
          <span className="text-amber-900 font-bold">
            {remainingDays} days (on {formattedDate})
          </span>
          . Reactivate your account to keep your data{' '}
          <span
            onClick={handleNavigate}
            className="text-amber-900 font-bold underline cursor-pointer hover:text-amber-700 transition-colors ml-1"
          >
            Reactivate Now
          </span>
        </p>
      </div>
    </div>
  );
};

export default DeletionBanner;
